import { render, staticRenderFns } from "./MultiBranchHelpList.vue?vue&type=template&id=947e019a&"
import script from "./MultiBranchHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiBranchHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports